import triggerEvent from '../utils/bi';
import { EventName } from '../types';
import { WIX_LOCALES_TYPE } from '../types/Locales';

export const getInstance = (): string => {
  if (typeof window !== 'undefined') {
    const url = window.location.search;
    // eslint-disable-next-line no-useless-escape
    const instanceRegexp = /.*instance=([\[\]a-zA-Z0-9\.\-_]*?)(&|$|#).*/g;
    const instance = instanceRegexp.exec(url);
    return instance && instance[1] ? instance[1] : '';
  }
  return '';
};
export const getSiteUrl = (): string => {
  if (!window.Wix) {
    return '';
  }
  return window.Wix.getSiteInfo((siteInfo: { baseUrl: string }) => {
    return siteInfo?.baseUrl || '';
  });
};

export const getOrigCompId = (): string => {
  return window.Wix
    ? window.Wix.Utils.getOrigCompId() || window.Wix.Utils.getCompId()
    : '';
};

export const getCompId = (): string => {
  return window.Wix
    ? window.Wix.Utils.getOrigCompId() || window.Wix.Utils.getCompId()
    : '';
};
export const getLocale = (): WIX_LOCALES_TYPE => {
  return window.Wix ? window.Wix.Utils.getLocale() : 'en';
};

export const resizeComponent = (
  width: number | Number,
  height: number | Number,
) => {
  if (window.Wix.Utils.getViewMode() !== 'site') {
    console.log('resizeComponent', width, height);
    window.Wix.Settings.resizeComponent({
      width,
      height,
    });
  }
};
export const isMobile = () => {
  return window.Wix ? window.Wix.Utils.getDeviceType() === 'mobile' : false;
};
export const OpenDashboardModal = (evName?: EventName, pageRoute?: string) => {
  const metaSiteId = window.Wix.Utils.getInstanceValue('metaSiteId') || '';
  const baseUrl = `https://manage.wix.com/dashboard/${metaSiteId}/adsense-bm/`;
  const dashboardUrl = baseUrl + pageRoute;
  console.log('@@dashboardUrl', evName, dashboardUrl);
  evName && triggerEvent(evName);
  const onCloseAdsBuilder = () => {
    console.log('@@onCloseAdsBuilder', evName, dashboardUrl);
    window.Wix.Settings.refreshAppByCompIds([window.Wix.Utils.getOrigCompId()]);
    window.location.reload();
  };
  window.Wix.Settings.openModal(
    dashboardUrl,
    '100%',
    '100%',
    '',
    onCloseAdsBuilder,
    'BARE',
  );
};
export const getWixPublicData = (key?: string, scope?: string) => {
  return new Promise((resolve, reject) => {
    window.Wix &&
      window.Wix.Data.Public.get(
        key,
        {
          scope,
        },
        (d: any) => {
          console.log('success on get data public', scope, d);
          resolve(d);
        },
        (f: any) => {
          reject(f);
        },
      );
  });
};
export const setWixPublicData = (
  key?: string,
  data?: {
    width: number;
    height: number;
  },
  scope?: string,
) => {
  window.Wix.Data.Public.set(
    key,
    data,
    { scope },
    (d: any) => {
      console.log('success on set data public', scope, d);
    },
    (f: any) => {
      console.log('error on save data public', scope, f);
    },
  );
};

export const removeWixPublicData = (key?: string, scope?: string) => {
  window.Wix.Data.Public.remove(
    key,
    { scope },
    (d: any) => {
      console.log('success on removeWixPublicData data public', scope, d);
    },
    (f: any) => {
      console.log('error on removeWixPublicData data public', scope, f);
    },
  );
};
